require('dotenv').config()
var { FIREBASE_API_URL } = process.env;
console.log("FIREBASE_API_URL", FIREBASE_API_URL);
WebFont.load({
    google: {
        families: [
            "Open Sans:300,300italic,400,400italic,600,600italic,700,700italic,800,800italic",
            "Manrope:200,300,regular,500,600,700,800",
            "Rubik:300,regular,500,600,700,800,900,300italic,italic,500italic,600italic,700italic,800italic,900italic",
        ],
    },
});
// Function to detect platform (Android, iOS, Desktop)
function getPlatform() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
        return 'Android';
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS';
    } else {
        return 'Desktop';
    }
}

// Function to check iOS version
function getiOSVersion() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const match = userAgent.match(/OS (\d+)_/i);
    return match ? parseInt(match[1], 10) : null;
}

// Main function to handle dynamic link routing
function handleDynamicLink(result) {
    const platform = getPlatform();
    const iOSVersion = getiOSVersion();
    console.log("platform", platform);
    console.log("iOSVersion", iOSVersion);
    console.log("result", result);

    // Define your deep links and store links
    const dynamicInfo = result?.link?.dynamicLinkInfo ?? {};
    const appDeepLink = dynamicInfo?.link ?? ''; // Replace with your actual app deep link
    const androidPackageName = dynamicInfo?.androidInfo?.androidPackageName ?? '';
    const iosBundleId = dynamicInfo?.iosInfo?.iosBundleId ?? '';
    const iosAppStoreId = dynamicInfo?.iosInfo?.iosAppStoreId ?? '';
    const playStoreLink = `https://play.google.com/store/apps/details?id=${androidPackageName}&url=${appDeepLink}&pcampaignid=fdl_long&hl=en_AU&pli=1`;
    const appStoreLink = `https://apps.apple.com/us/app/id${iosAppStoreId}`;

    document.getElementById("cardImage").src = result?.card?.frontView;
    const link = platform === 'iOS' ? appStoreLink : playStoreLink
            
    document.getElementById("app-store-cta-button").style.display = "inline-block";
    document.getElementById("loader").style.display = "none";

    const ctaButton = document.getElementById("app-store-cta-button");
    ctaButton.href = link;
    ctaButton.click();
}

// Run the dynamic link handler on page load or link click
// Define an async function to fetch the short link
async function getShortLink() {
    // Get the current path from the URL
    const path = window.location.pathname.replace("/", "");

    // Prepare the request payload
    const data = {
        "linkId": path
    };

    // Set the headers
    const headers = {
        "Content-Type": "application/json"
    };

    // API URL to get the short link
    try {
        // Send POST request using axios
        const response = await axios.post(`${FIREBASE_API_URL}/shortlink`, data, { headers });
        const result = response.data;
        handleDynamicLink(result);
        // });
    } catch (error) {
        console.log('[getShortLinkHttpError]', {error})
        document.getElementById("qr-content").style.display = "inline-block";
        document.getElementById("loader").style.display = "none";
    }
}

document.addEventListener("DOMContentLoaded", function () {
    displayElements();
});

function displayElements() {
    // Always hide the app store CTA button
    document.getElementById("app-store-cta-button").style.display = "none";

    const platform = getPlatform();
    if (platform === 'Desktop') {
        return;
    }

    const path = window.location.pathname.replace("/", "");

    if (path === '') {
        document.getElementById("qr-content").style.display = "inline-block";
        document.getElementById("loader").style.display = "none";
    } else {
        getShortLink();
    }
}